import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconsService {
  icons = [
    'error-file',
    'email',
    'lock',
    'person',
    'eye',
    'arrow_up',
    'status-info',
    'eye-slash',
    'chat',
    'settings',
    'send',
    'brightness',
    'image',
    'clip',
    'logout',
    'moon',
    'filters',
    'search',
    'check',
    'check_all',
    'mic',
    'mic_off',
    'videocam',
    'videocam_off',
    'bookmark',
    'bookmark_off',
    'volume_off',
    'volume',
    'more_vert',
    'back',
    'info',
    'close',
    'copy',
    'external-link',
    'translate',
    'close_circle',
    'assistant',
    'arrow_down',
    'add_person',
    'trash',
    'call',
    'call_end',
    'access_time',
    'fullscreen',
    'fullscreen_exit',
    'roles',
    'tag',
    'arrow_right',
    'plus',
    'pencil',
    'list',
    'new_videocall',
    'gif',
    'emoji',
    'error',
    'warning',
    'whatsapp',
    'sms',
    'file_download',
    'support_agent',
    'download',
    'reload',
    'chatbot',
    'human-chat',
    'users',
    'megaphone',
  ];
  constructor(private domSanitizer: DomSanitizer, private iconRegistry: MatIconRegistry) {}
  loadIcons(url: string, icons = this.icons): void {
    for (const icon of icons) {
      this.iconRegistry.addSvgIcon(icon, this.domSanitizer.bypassSecurityTrustResourceUrl(`${url}/icons/${icon}.svg`));
    }
  }
}
